import React from 'react';
import ServicePage from '../../components/ServicePage';
import { Zap, ShieldAlert, Microscope, ShieldHalf, Lock, FileBadge, ShieldCheck, PhoneCall, Car, BarChart } from 'lucide-react';

export default function EmergencyResponse() {
  return (
    <ServicePage
      title="应急响应服务"
      subtitle="攻击溯源 + 取证分析 + 业务恢复三合一处置"
      description="安全事件触发后，卓迈应急响应团队极速到达现场。我们提供三合一处置——攻击溯源（知道谁打的）、取证分析（知道损失了什么）、业务恢复（知道怎么最快恢复）。不只是「灭火」，而是帮你彻底清除后门、封堵漏洞，防止二次入侵。"
      icon={<Zap size={40} strokeWidth={1.5} />}
      color="#d97706"
      benefits={[
        '专业团队极速响应，迅速到场处置',
        '攻击溯源 + 取证分析 + 业务恢复三合一',
        'DFIR 专家团队，平均处置经验 8 年以上',
        '完整攻击链溯源，出具法律有效取证报告',
        '处置后提供 30 天安全巩固加固方案',
      ]}
      features={[
        {
          icon: <ShieldAlert size={24} />,
          title: '快速研判与现场响应',
          desc: '接到报告后 30 分钟内完成远程初步研判，评估事件级别（P0-P3），制定处置预案。P0/P1 级事件专家极速到场，携带专业取证设备直接开工。',
          points: ['30min 远程初步研判', '极速到场 SLA 保障', 'P0-P3 事件分级标准', '7×24 应急热线响应'],
        },
        {
          icon: <Microscope size={24} />,
          title: '攻击溯源分析',
          desc: '通过日志分析、内存取证、流量回溯等手段，还原完整攻击时间线——初始入口、横向路径、驻留机制、数据外泄范围，告诉你「谁打进来的、怎么打的、拿走了什么」。',
          points: ['完整攻击时间线还原', '初始突破点精准定位', '横向移动路径溯源', '数据外泄范围评估'],
        },
        {
          icon: <ShieldHalf size={24} />,
          title: '恶意代码清除',
          desc: '专项查杀 Webshell、后门程序、内存马、持久化机制，支持 PHP/JSP/ASP 全类型 Webshell 识别，清除后验证残余风险，确保彻底清净。',
          points: ['Webshell 深度扫描清除', '内存马检测与清理', '持久化机制全清除', '清除后验证复查'],
        },
        {
          icon: <Lock size={24} />,
          title: '紧急加固处置',
          desc: '在清除攻击载体的同时，紧急修复被利用的高危漏洞，临时加固失陷系统，最快速度恢复业务，最小化停摆影响。平均业务恢复时间 < 8 小时。',
          points: ['高危漏洞紧急补丁', '失陷账号清理重置', '业务恢复时间 < 8H', '恢复后安全验证'],
        },
        {
          icon: <FileBadge size={24} />,
          title: '法律有效取证报告',
          desc: '按照《网络安全法》和电子证据司法解释标准，出具具备法律效力的电子取证报告，可用于向公安机关报案、保险理赔、合同纠纷追责等场景。',
          points: ['符合《网安法》取证标准', '电子证据哈希固化', '完整证据链文档', '支持公安报案协助'],
        },
        {
          icon: <ShieldCheck size={24} />,
          title: '30 天安全巩固方案',
          desc: '处置完成后不「一走了之」，提供 30 天跟踪服务：漏洞修复验证、安全加固建议、入侵指标（IOC）持续监控，确保不会被同一攻击方式二次入侵。',
          points: ['漏洞修复验证复测', 'IOC 持续监控 30 天', '安全加固改进建议', '二次入侵预警机制'],
        },
      ]}
      process={[
        { icon: <PhoneCall size={24} />, title: '接报研判', desc: '接到报告 30 分钟内完成远程初步研判，确定事件级别和响应资源' },
        { icon: <Car size={24} />, title: '快速到场', desc: 'P0/P1 事件专家携设备极速到达现场，远程可实时视频协同指导' },
        { icon: <Microscope size={24} />, title: '取证溯源', desc: '内存取证、日志回溯、流量分析三合一，还原完整攻击时间线' },
        { icon: <ShieldHalf size={24} />, title: '清除处置', desc: '清除恶意代码、修复漏洞、重置失陷凭证，紧急恢复业务系统' },
        { icon: <BarChart size={24} />, title: '报告与加固', desc: '提交取证报告 + 30 天安全巩固方案，跟踪验证处置效果' },
      ]}
      nextService={{ name: '漏洞扫描服务', path: '/services/vuln-scan' }}
    />
  );
}
